/* eslint-disable no-use-before-define */
import { getEpiCartItems } from '../utils/cart-utils';

const getMiniCartHtml = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/cart/MiniCartDetails`;
  fetch(url)
    .then(r => r.text())
    .then(updateMiniCartHtml)
    .catch(console.error);
};

/* const onRemoveItemClick = (e) => {
  const code = e.target.getAttribute('data-code');
  removeFromEpiCart(code)
    .then(getMiniCartHtml)
    .catch(console.error);
}; */

const initMiniCart = () => {
  getEpiCartItems()
    .then((cart) => {
      const icon = document.querySelector('.icon-item-cart');
      if (!icon) {
        return;
      }
      if (cart.items.length) {
        icon.classList.add('items-added-to-cart');
      } else {
        icon.classList.remove('items-added-to-cart');
      }
    })
    .catch(console.error);
  // const itemList = document.getElementById('mini-cart-items-list');
  /* if (!itemList) {
    return;
  } */
  /* Array.from(itemList.children).forEach((li) => {
    const btn = li.querySelector('.mini-cart-rm');
    btn.onclick = onRemoveItemClick;
  }); */
};

const updateMiniCartHtml = (html) => {
  const miniCartDiv = document.querySelector('.cart-content-wrap');
  if (!miniCartDiv) {
    return;
  }

  miniCartDiv.innerHTML = html;
  initMiniCart();
};

export {
  getMiniCartHtml,
  initMiniCart,
};
/* eslint-enable no-use-before-define */
